<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${currentHeroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">Elegance Starts with the Perfect Ethnic Look</div>
          <div class="hero-desc">
            Discover kurtas, sarees, palazzos and ethnic sets crafted for the modern Indian woman. Graceful silhouettes, premium fabrics — style that feels like you.
          </div>
          <router-link class="hero-btn" to="/goods">Shop Now</router-link>
        </div>
        <div class="hero-dots">
          <span
            v-for="(img, idx) in heroImages"
            :key="idx"
            class="hero-dot"
            :class="{ active: heroIndex === idx }"
            @click="setHeroIndex(idx)"
          ></span>
        </div>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <h2>New Arrivals</h2>
          <p>Fresh ethnic styles just for you</p>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹499</p>
          </div>
          <div class="why-item">
            <div class="why-icon">👗</div>
            <h3>Premium Quality</h3>
            <p>Curated fabrics &amp; fine craftsmanship</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Easy Returns</h3>
            <p>7-day hassle-free returns</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payment</h3>
            <p>UPI, COD &amp; cards accepted</p>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Curated Ethnic Wear</h2>
              <p>Handpicked styles for every occasion</p>
            </div>
            <div class="section-tabs">
              <span class="tab-item" :class="{active: discoverActive==='KURTAS'}" @click="discoverActive='KURTAS'">KURTAS</span>
              <span class="tab-item" :class="{active: discoverActive==='SAREES'}" @click="discoverActive='SAREES'">SAREES</span>
              <span class="tab-item" :class="{active: discoverActive==='TOPS'}" @click="discoverActive='TOPS'">TOPS</span>
              <span class="tab-item" :class="{active: discoverActive==='PALAZZOS'}" @click="discoverActive='PALAZZOS'">PALAZZOS</span>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
          <router-link class="section-cta" to="/goods">See More</router-link>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Time Offer</span>
            <h2>FESTIVE COLLECTION 2026</h2>
            <p>Up to 40% Off on Kurtas, Sarees &amp; Ethnic Sets</p>
            <router-link class="promo-btn" to="/goods">Shop Now</router-link>
          </div>
          <div class="promo-image">
            <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/30479731/img_00.jpg" alt="Floral Embroidered A-Line Kurta Set" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Kurtas &amp; Kurta Sets</div>
              <div class="split-desc">
                Embroidered kurtas and elegant kurta sets — timeless silhouettes in premium fabrics for every occasion.
              </div>
              <router-link class="section-cta" to="/goods">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/22260184/img_00.jpg" alt="Silk Ethnic Palazzos" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Palazzos &amp; Leggings</div>
              <div class="split-desc">
                Comfortable, flattering bottoms that pair beautifully with kurtas and ethnic tops — everyday ease, all-day style.
              </div>
              <router-link class="section-cta" to="/goods">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/29539062/img_00.jpg" alt="Women A-line Maxi Skirt" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as productsAPI from '@/api/products/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据（后端接口，已忽略：Hero 由下方精选女装图池提供）
      // 女装分类商品列表（Discover 区，对应 sql/女装.sql 分类 ID）
      kurtasList: [],     // 61 women-kurtas-kurtis-suits
      sareesList: [],     // 63 saree
      palazzosList: [],   // 66 skirts-palazzos
      topsList: [],       // 62 ethnic-tops
      discoverActive: 'KURTAS', // Discover section active tab
      kurtasProdList: [],
      sareesProdList: [],
      palazzosProdList: [],
      topsProdList: [],
      // Hero 轮播：精选女装图池（OSS shop5 路径，来自 sql/女装.sql img_path）
      heroImages: [
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/14357452/img_00.jpg', // Sequinned Half and Half Saree
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/30575425/img_00.jpg', // Chanderi Cotton Anarkali
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/37787055/img_00.jpg', // Embroidered Thread Work Kurta
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/41358896/img_00.jpg', // Chikankari Ethnic Top
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/41714499/img_00.jpg'  // Fit and Flare Ethnic Dress
      ],
      heroIndex: 0,
      heroTimer: null,
      start: 0,
      limit: 7,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    currentHeroImage() {
      // 直接使用精选女装图池，忽略后端 carousels
      return this.heroImages[this.heroIndex] || this.heroImages[0]
    },
    discoverProducts() {
      if (this.discoverActive === 'KURTAS') return this.kurtasProdList
      if (this.discoverActive === 'SAREES') return this.sareesProdList
      if (this.discoverActive === 'TOPS') return this.topsProdList
      return this.palazzosProdList
    }
  },
  activated() {
    // 获取首页数据
    this.load()
    this.startHeroRotation()
  },
  deactivated() {
    this.stopHeroRotation()
  },
  beforeDestroy() {
    this.stopHeroRotation()
  },
  methods: {
    // Hero 轮播控制
    setHeroIndex(idx) {
      this.heroIndex = idx
    },
    startHeroRotation() {
      this.stopHeroRotation()
      if (!this.heroImages || this.heroImages.length < 2) return
      this.heroTimer = setInterval(() => {
        this.heroIndex = (this.heroIndex + 1) % this.heroImages.length
      }, 5000)
    },
    stopHeroRotation() {
      if (this.heroTimer) {
        clearInterval(this.heroTimer)
        this.heroTimer = null
      }
    },
    load() {
      // 不再请求后端 carousels 接口。Hero 轮播由精选女装图池提供。
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)

            // Discover section: women's ethnic categories
            this.findDiscoverCategories(list)
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
      // Discover section: women's ethnic category product lists
      this.getProduct(61, 'kurtasProdList')    // Kurtas, Kurtis & Suits
      this.getProduct(63, 'sareesProdList')    // Sarees
      this.getProduct(62, 'topsProdList')      // Ethnic Tops
      this.getProduct(66, 'palazzosProdList')  // Skirts & Palazzos
    },
    // Find women's ethnic categories for the Discover section
    findDiscoverCategories(list) {
      const kurtasCat = list.find(c => (c.category_name || '').toLowerCase() === 'women-kurtas-kurtis-suits')
      if (kurtasCat) this.getProduct(kurtasCat.category_id, 'kurtasProdList')

      const sareesCat = list.find(c => (c.category_name || '').toLowerCase() === 'saree')
      if (sareesCat) this.getProduct(sareesCat.category_id, 'sareesProdList')

      const topsCat = list.find(c => (c.category_name || '').toLowerCase() === 'ethnic-tops')
      if (topsCat) this.getProduct(topsCat.category_id, 'topsProdList')

      const palazzosCat = list.find(c => (c.category_name || '').toLowerCase() === 'skirts-palazzos')
      if (palazzosCat) this.getProduct(palazzosCat.category_id, 'palazzosProdList')
    },
    selectCategory(id) {
      if (this.activeCategoryId === id) return
      this.activeCategoryId = id
      this.homeStart = 0
      this.fetchHomeProducts(id)
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            this.homeProducts = this.shuffle(Array.isArray(res.data.items) ? res.data.items : [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // 获取各类商品数据方法封装
    getProduct(categoryID, val) {
      productsAPI
        .listProducts(categoryID, this.start, this.limit)
        .then(res => {
          if (res.status === 200) {
            this[val] = this.shuffle(res.data.items || [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle
    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#F8FAFC')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#F8FAFC')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';
</style>
